import { render } from "./PayTemplate.vue?vue&type=template&id=3b6b2830"
import script from "./PayTemplate.vue?vue&type=script&lang=js"
export * from "./PayTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__